import React from 'react';
import { __, _n, sprintf } from '@wordpress/i18n';

// store
import { useCommCenter } from '../../context';

const KIND_LABELS = {
    video: __('video', 'soundbetween'),
    rec: __('sessione rec', 'soundbetween'),
};

/**
 * Says out loud that the list below is showing only what belongs to whatever is
 * selected — cue sheet rows, timeline tracks, items of the My Studio panel —
 * and gives one click to go back to the whole feed.
 *
 * Activities now carry the entity they are about, so any selection can scope
 * them. A message does not, so the Comunicazioni tab can only follow a cue, and
 * a selection it cannot match is named as such instead of looking like an empty
 * project.
 *
 * @param {string} subject 'activities' | 'comments' — which tab is talking
 */
const ScopeBar = ({ subject = 'activities' }) => {
    const { activityScope, clearActivityScope } = useCommCenter();

    if (!activityScope) return null;

    const { supportsComments, labels = [], count, kind } = activityScope;
    const isComments = subject === 'comments';
    const supported = isComments ? supportsComments : true;

    const named = isComments
        ? __('Commenti di %s', 'soundbetween')
        : __('Attività di %s', 'soundbetween');
    const counted = isComments
        ? _n('Commenti di %d elemento selezionato', 'Commenti di %d elementi selezionati', count, 'soundbetween')
        : _n('Attività di %d elemento selezionato', 'Attività di %d elementi selezionati', count, 'soundbetween');
    const unsupported = isComments
        ? __('Nessun commento collegato a: %s', 'soundbetween')
        : __('Nessuna attività collegata a: %s', 'soundbetween');

    const description = supported
        ? sprintf(labels.length ? named : counted, labels.length ? labels.join(', ') : count)
        : sprintf(unsupported, KIND_LABELS[kind] || kind);

    return (
        <div className="commScopeBar">
            <span className="commScopeBar__label" title={description}>{description}</span>
            <button
                type="button"
                className="commScopeBar__clear"
                onClick={clearActivityScope}>
                {__('Mostra tutte', 'soundbetween')}
            </button>
        </div>
    )
}

export default ScopeBar;
